export enum featureCode {
  AUTO_APPROVE_USER = "AUTO_APPROVE_USER", // Tự động duyệt người tham gia
  AUTH_FACEID = "AUTH_FACEID", // Xác thực khuôn mặt
  ALLOW_POLL = "ALLOW_POLL", // Cho phép thăm dò ý kiến
  ALLOW_EXTENT_MTIME = "ALLOW_EXTENT_MTIME", // Cho phép gia hạn thời gian cuộc họp
  ALLOW_CHAT_FILE = "ALLOW_CHAT_FILE", // Cho phép gửi file, tập tin khi chat
  ALLOW_CHAT_PRIVATE = "ALLOW_CHAT_PRIVATE", // Cho phép chat riêng tư  
  ALLOW_CHAT_PUBLIC = "ALLOW_CHAT_PUBLIC", // Cho phép trò chuyện công khai (public)
  ALLOW_EDIT_DISPLAY_NAME = "ALLOW_EDIT_DISPLAY_NAME", // Cho phép người tham gia đổi tên hiển thị
  ALLOW_EDIT_ROOM_NAME = "ALLOW_EDIT_ROOM_NAME", //Cho phép đổi tên cuộc họp
  AUTO_START_RECORD = "AUTO_START_RECORD", //Tự động bật ghi hình cuộc họp
  ALLOW_RECORD = "ALLOW_RECORD", //Cho phép sử dụng ghi hình
  ALLOW_WHITEBOARD = "ALLOW_WHITEBOARD", //Cho phép sử dụng bảng trắng
  ALLOW_SUMMARY = "ALLOW_SUMMARY", //Sử dụng tóm tắt cuộc họp
  ALLOW_OPEN_MIC = "ALLOW_OPEN_MIC", //Cho phép mở mic
  ALLOW_OPEN_CAM = "ALLOW_OPEN_CAM", //Cho phép mở camera
  ALLOW_WEBINAR = "ALLOW_WEBINAR",
  ALLOW_LIVECAPTION = "ALLOW_LIVECAPTION" // Chức năng phụ đề
}
